<template>
  <div class="form-block cropcompones" style="position: relative;">
    <div
      class="uploaddiv firstupload"
      :style="{'display':isupload ? 'block' :'none'}"
      :class="{showtextstyle:showtext}"
    >
      <el-button type="primary" class="btn-upload">
        <input type="file" accept="image/*" @change="thumb_selectimg" class="upInputCrop" />
      </el-button>
      <span
        class="change"
        :class="{showtop:showtext}"
      >{{showtext?$t('global.修改头像'):$t('global.选择图片')}}</span>
      <span
        v-if="showtext"
        style="display: block;width:108px;height:108px;border-radius:54px;background-color:#d8d8d8;margin:0 auto 5px;"
      ></span>
      <img class="staticimg" v-if="!showtext" src="/static/uploadvideo/staticicon.png" />
    </div>

    <div
      class="curtforbox"
      :style="{'width':dialogWidth+'px','height':dialogHeight+'px'}"
      v-if="thumbState"
    >
      <div class="whitefix" :style="{'width':dialogWidth+'px','height':dialogHeight+'px'}">
        <span @click="getImg" class="getImgbtns">{{$t('global.确定')}}</span>
        <span @click="canceled">{{$t('global.取消')}}</span>
      </div>
      <vueCropper
        :style="{'width':dialogWidth-50+'px','height':dialogHeight-110+'px'}"
        class="thumbCropper"
        ref="thumbCropper"
        :img="option.img"
        :size="size"
        :outputSize="option.size"
        :outputType="option.outputType"
        :info="true"
        :full="option.full"
        :canMove="option.canMove"
        :canMoveBox="option.canMoveBox"
        :fixedBox="option.fixedBox"
        :fixed="option.fixed"
        :fixedNumber="option.fixedNumber"
        :original="option.original"
        :autoCrop="option.autoCrop"
        :autoCropWidth="option.autoCropWidth"
        :autoCropHeight="option.autoCropHeight"
        :centerBox="option.centerBox"
        :high="option.high"
        :infoTrue="option.infoTrue"
        :enlarge="option.enlarge"
        :maxImgSize="option.maxImgSize"
      ></vueCropper>
    </div>
    <img :src="img | imageUrl" style="display: none" />
  </div>
</template>

<script>
import VueCropper from "@/assets/lib/vue-cropper";
export default {
  name: "CropImg",
  // props: [
  //   "cropWidth",
  //   "cropHeight",
  //   "dialogWidth",
  //   "dialogHeight",
  //   "isUpload",
  //   "minWidth",
  //   "minHeight",
  //   "showtext"
  // ],
  props: {
      cropWidth: {
        type: Number,
        default: 0
      },
      cropHeight: {
        type: Number,
        default: 0
      },
      dialogWidth: {
        type: Number,
        default: 0
      },
      dialogHeight: {
        type: Number,
        default: 0
      },
      isUpload: {
        type: Boolean,
        default: false
      },
      minWidth: {
        type: Number,
        default: 0
      },
      minHeight: {
        type: Number,
        default: 0
      },
      showtext: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: true
      },
      fixedNumber: {
        type: Array,
        default: [1,1]
      },
      fixedBox: {
        type: Boolean,
        default: false
      },
      original: {
        type: Boolean,
        default: false
      },
      maxImgSize: {
        type: Number,
        default: 5000
      }
  },

  components: {
    VueCropper
  },
  data() {
    return {
      option: {
        img: "",
        size: 1,
        outputType: "jpeg",
        full: true,
        canMove: true,
        fixedBox: this.fixedBox,
        original: this.original,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: this.cropWidth,
        autoCropHeight: this.cropHeight,
        fixed: this.fixed,
        fixedNumber: this.fixedNumber,
        infoTrue: true,
        centerBox: false,
        high: false,
        cropData: {},
        enlarge: 1,
        mode: "contain",
        maxImgSize: this.maxImgSize
      },
      thumbState: false,
      img: "",
      isupload: false,
      size: null
    };
  },
  methods: {
    thumb_selectimg(e) {
      let file = e.target.files[0];
      let $this = this;
      if (this.minWidth != "") {
        let file_ = document.querySelector(".upInputCrop");
        this.$jsonUtils.checkImageSize(
          file_,
          file,
          Number(this.minWidth),
          Number(this.minHeight),
          function(data) {
            if (data.state) {
              var reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function(e) {
                $this.option.img = this.result;
                setTimeout(() => {
                  document.querySelector(".thumbCropper").addEventListener(
                    "mousewheel",
                    e => {
                      if (e.ctrlKey) {
                        e.preventDefault();
                      }
                    },
                    { passive: false }
                  );
                }, 0);
                $this.thumbState = true;
                document.documentElement.style.overflowY = "hidden";
              };
            } else {
              $this.$message.info(
                $this.$t("global.文件大小不能小于") +
                  $this.minWidth +
                  " * " +
                  $this.minHeight
              );
            }
          }
        );
      } else {
        if (file.type === "image/gif") {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function(e) {
            $this.$emit("update-img", { data: this.result });
          };
        } else {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function(e) {
            $this.option.img = this.result;
            $this.thumbState = true;
            document.documentElement.style.overflowY = "hidden";
          };
        }
      }
    },
    getImg() {
      this.$refs.thumbCropper.getCropData(data => {
        this.img = data;
        this.thumbState = false;
        document.documentElement.style.overflowY = "scroll";
      });
    },
    canceled() {
      this.thumbState = false;
      document.documentElement.style.overflowY = "scroll";
    },
    reUpload(value) {
      if (value) {
        this.size = value;
      }
      document.querySelector(".upInputCrop").value = "";
      document.querySelector(".upInputCrop").click();
      this.isupload = false;
    }
  },
  created() {
    this.isupload = this.isUpload;
  },
  watch: {
    img() {
      this.$emit("update-img", { data: this.img });
    },
    isUpload() {
      this.isupload = this.isUpload;
    }
  }
};
</script>

<style lang="stylus" scoped>
.no-img {
  display: block;
  width: 2rem;
  height: 2rem;
  margin: 1.4rem auto 0;
}

.no-content {
  font-size: 0.26rem;
  color: #dddddd;
  text-align: center;
  margin-top: 0.4rem;
}

.curtforbox div.vue-cropper {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 9999;
  transform: translate(-50%, -50%);
}

.uploaddiv {
  position: relative;
  width: 582px;
  height: 180px;
}

.uploaddiv button {
  position: absolute;
  top: 50%;
  padding: 0;
  width: 582px;
  height: 180px;
  left: 50%;
  border: none;
  outline: none;
  overflow: hidden;
  z-index: 99;
  opacity: 0;
  transform: translate(-50%, -50%);
}

.uploaddiv button span, .uploaddiv button span input {
  display: inline-block;
  // width: 100%;
  height: 100%;
}

.uploaddiv .change {
  position: absolute;
  top: 63%;
  left: 50%;
  z-index: 9;
  color: #333;
  font-size: 14px;
  transform: translate(-50%, -50%);
}

.staticimg {
  position: absolute;
  top: 44%;
  left: 50%;
  z-index: 9;
  transform: translate(-50%, -50%);
}

.curtforbox:before {
  position: fixed;
  display: block;
  content: '';
  width: 100%;
  height: 100vh;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
}

.curtforbox div.vue-cropper {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 9999;
  transform: translate(-50%, -50%);
}

.cropper-crop-box {
  width: 580px !important;
  height: 180px !important;
}

.curtforbox div.whitefix {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 9998;
  /* width: 1500px;
  height: 600px; */
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 1px 1px 3px #000;
}

.getImgbtns {
  display: inline-block;
  width: 70px;
  height: 40px;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  margin-left: 8px;
  cursor: pointer;
  background-color: #409EFF;
}

.whitefix .getImgbtns {
  position: absolute;
  right: 90px;
  bottom: 10px;
}

.whitefix span:last-child {
  position: absolute;
  display: inline-block;
  width: 70px;
  height: 40px;
  border-radius: 4px;
  color: #ccc;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  cursor: pointer;
  right: 10px;
  bottom: 10px;
  border: 1px solid #EDECF1;
}

.whitefix span:last-child:hover {
  background: rgba(51, 51, 51, 0.1);
}

.showtextstyle {
  width: 100%;
}

.uploaddiv .showtop {
  margin-top: 7px;
  color: #446EEB;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/CropImg.vue